import script from "./checkTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./checkTickets.vue?vue&type=script&setup=true&lang=js"

import "./checkTickets.vue?vue&type=style&index=0&id=d53abb06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d53abb06"]])

export default __exports__